<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg" v-if="formData.key == 'note'">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('NOTE')">
        <inputvalidation :formerror="formError" name="note">
          <b-form-textarea v-model="formData.note" type="text" :rows="3" :max-rows="6"></b-form-textarea>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg" v-if="formData.key == 'anamnestic'">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('ANAMNESTICFORM')">
        <wysiwyg v-model="formData.anamnestic"/>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg" v-if="formData.key == 'communication'">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('COMMUNICATIONFORM')">
        <wysiwyg v-model="formData.communication"/>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg" v-if="formData.key == 'instrument'">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('INSTRUMENTFORM')">
        <wysiwyg v-model="formData.instrument"/>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg" v-if="formData.key == 'opinion'">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('OPINIONFORM')">
        <wysiwyg v-model="formData.opinion"/>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg" v-if="formData.key == 'diagnose'">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('DIAGNOSE')">
        <inputvalidation :formerror="formError" name="diagnoseId">
             <lb-vue-select v-model= "formData.diagnoseId"
                            :list= "diagnose.root"
                            :totalCount= "diagnose.totalCount"
                            :pagination= "diagnosepagi"
                            display-field= "name"
                            value-field= "diagnoseId"
                            multiselect="true"
                            :search-placeholder= "$t('SEARCH')"
                            :items-placeholder= "$t('DIAGNOSE')">
              </lb-vue-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
import DiagnoseApi from '@/api/diagnose/Diagnose';

export default
{
    name: 'ChildForm',
    props: ['formData', 'formError'],
    data()
    {
        return {
            diagnose: {},
            diagnosepagi:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          initialId: [],
          searchTimeout: false,
      },
        };
    },
    created()
    {
        const me = this;
        me.getDiagnose();
    },
    methods:
  {
      async getDiagnose()
      {
          const me = this;
          try
          {
              const data = await DiagnoseApi.selectRow(me.getDiagnoseParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.diagnose = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
  },
    watch:
  {
      'diagnosepagi.limit'()
      {
          const me = this;
          me.getDiagnose();
      },
      'diagnosepagi.currentPage'()
      {
          const me = this;
          me.getDiagnose();
      },
      'diagnosepagi.query'()
      {
          const me = this;
          me.getDiagnose();
      },
  },
    computed:
  {
      getDiagnoseParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
